import React from "react";
import { Row, Col, Button } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

const OrgDetailsSkeletonLoaderComponents = () => {
  return (
    <Row className="orgd__inner">
      <Col className="orgd__left" lg={9}>
        <div className="orgd__title mb-3 d-flex align-items-start justify-content-between position-relative">
          <div className="orgd__tileft">
            <h3 className="mb-1 pb-1 fw-bold text-dark">
              <Skeleton width={250} />
            </h3>
            <p className="mb-0 d-flex align-items-center">
              <Skeleton circle width={20} height={20} className="me-1" />
              <Skeleton width={200} />
            </p>
          </div>
          <div className="orgd__tiright bg-white rounded-pill d-flex align-items-center gap-1">
            <Skeleton circle width={24} height={24} />
            <Skeleton circle width={24} height={24} />
          </div>
        </div>
        <div className="orgd__content bg-white p-3">
          <div className="orgd__conitems conitems__top gap-3">
            <div className="conitems__img mb-3">
              <Skeleton className="w-100 h-100" />
            </div>
            <div className="conitems__summary mb-3">
              <h4 className="conitems__title text-dark fw-bold">
                <Skeleton width={150} />
              </h4>
              <div className="summary__content">
                <Skeleton count={3} />
              </div>
            </div>
          </div>
          <div className="orgd__conitems conitems__pathway mb-3">
            <h6 className="fw-bold text-dark mb-2">
              <Skeleton width={100} />
            </h6>
            <div className="lright__list d-flex flex-wrap gap-2">
              {[...Array(3)].map((_, idx) => (
                <Skeleton
                  key={idx}
                  width={80}
                  height={25}
                  className="rounded-pill"
                />
              ))}
            </div>
          </div>
          <div className="orgd__conitems conitems__targetgroup mb-3">
            <h4 className="conitems__title text-dark fw-bold">
              <Skeleton width={150} />
            </h4>
            <ul className="target__list m-0 ps-2">
              {[...Array(3)].map((_, idx) => (
                <li key={idx} className="text-gray position-relative">
                  <Skeleton width={120} />
                </li>
              ))}
            </ul>
          </div>
          <div className="orgd__conitems conitems__reviews">
            <div className="review__title d-flex justify-content-between align-items-center mb-3">
              <h4 className="conitems__title text-dark fw-bold mb-0">
                <Skeleton width={120} />
              </h4>
              <Button variant="light" className="rounded-pill">
                <Skeleton width={100} height={30} />
              </Button>
            </div>
            <div className="review__head mb-4">
              <Row className="g-4">
                <Col md={4}>
                  <div className="rhead__left h-100 d-flex flex-column align-items-center justify-content-center">
                    <Skeleton width={50} height={50} />
                    <Skeleton width={80} />
                    <Skeleton width={100} />
                  </div>
                </Col>
                <Col md={8}>
                  <div className="rhead__right">
                    {[...Array(5)].map((_, idx) => (
                      <div
                        key={idx}
                        className="rhead__ritems d-flex align-items-center gap-3 mb-2"
                      >
                        <Skeleton width={50} />
                        <Skeleton width="100%" height={8} />
                        <Skeleton width={40} />
                      </div>
                    ))}
                  </div>
                </Col>
              </Row>
            </div>
            <div className="review__body">
              {[...Array(2)].map((_, idx) => (
                <div key={idx} className="rbody__items bg-white p-3 mb-3">
                  <Skeleton width={120} />
                  <Skeleton width={80} />
                  <Skeleton count={2} />
                </div>
              ))}
            </div>
          </div>
        </div>
      </Col>
      <Col className="orgd__right mt-3 mt-lg-0" lg={3}>
        <div className="orgd__rbox bg-white p-3">
          <div className="orgd__rcard mb-3">
            <div className="orgd__review">
              <div className="d-flex flex-column align-items-center">
                <div className="d-flex align-items-center gap-1 mb-0">
                  <Skeleton width={36} height={20} />
                  <Skeleton cricle width={20} height={20} />
                </div>
                <Skeleton width={80} height={16} />
              </div>
            </div>
          </div>
          <div className="orgd__rcard mb-3">
            {[...Array(3)].map((_, idx) => (
              <div
                key={idx}
                className="orgd__coitems d-flex align-items-center gap-3 mb-2"
              >
                <Skeleton circle width={24} height={24} />
                <Skeleton width={150} />
              </div>
            ))}
          </div>
          <div className="orgd__rcard">
            <div className="orgd__social d-flex align-items-center justify-content-center gap-3">
              {[...Array(3)].map((_, idx) => (
                <Skeleton
                  key={idx}
                  circle
                  width={40}
                  height={40}
                  className="rounded-pill"
                />
              ))}
            </div>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default OrgDetailsSkeletonLoaderComponents;
